module.exports = __webpack_public_path__ + "static/media/sportIcon.24216c1d.svg";